import React, { useEffect, useState } from "react";
import { Table, Input, Space, message, Modal } from "antd";
import ColumnsConfig, { PartnerListData } from "./ColumnsConfig";
import PageWrapper from "../../../Layout/PageWrapper";
import styles from "./InvoiceParterList.module.css";
import { useNavigate } from "react-router-dom";
import { InvoiceService } from "../../../services/Invoices/InvoiceService/InvoiceService";
import { mapProfileToPartnerList } from "./Mapper";
import StatusUpdateModal from "./StatusUpdateModal";

const { Search } = Input;

const InvoicePartnerList: React.FC = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<PartnerListData[]>([]);
	const [filteredData, setFilteredData] = useState<PartnerListData[]>([]);
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedProfileId, setSelectedProfileId] = useState<string | null>(null);

	useEffect(() => {
		getInvoicePartnerList();
	}, []);

	const getInvoicePartnerList = async () => {
		setLoading(true);
		try {
			const res = await InvoiceService.getInvoicePartnerList();
			const filtered = mapProfileToPartnerList(res.data);
			setData(filtered);
			setFilteredData(filtered);
		} catch (error: any) {
			if (error?.status === 429) message.error("Too many requests. Please try again later.");
			else message.error(error?.response?.data?.message || "Something went wrong");
		} finally {
			setLoading(false);
		}
	};

	const handleView = (key: string) => {
		navigate("/admin/invoice-partner/detail/" + key+"/payers");
	};

	const handleApprove = (profileId: string) => {
		setModalOpen(true);
		setSelectedProfileId(profileId);
		// Modal.confirm({
		// 	title: "Confirm Approval",
		// 	content: "Do you really want to approve this profile?",
		// 	okText: "Yes, Approve",
		// 	cancelText: "No",
		// 	okType: "primary",
		// 	onOk: async () => {
		// 		await handleApproveProfile(profileId);
		// 	}
		// });
	};

	const handleApproveProfile = async (profileId: string, profileStatusId: number, content: string) => {
		setLoading(true);
		try {
			const res = await InvoiceService.updateProfileStatus(profileId, profileStatusId, content);
			if (res.data) message.success(res.message);
			getInvoicePartnerList();
		} catch (error: any) {
			if (error?.status === 429) message.error("Too many requests. Please try again later.");
			else message.error(error?.response?.data?.message || "Something went wrong");
		} finally {
			setLoading(false);
		}
	};

	const handleSearch = (value: string) => {
	const searchText = value.toLowerCase().trim();

	const result = data.filter((item) =>
		Object.values(item).some((val) =>
			String(val ?? "")
				.toLowerCase()
				.includes(searchText)
		)
	);

	setFilteredData(result);
};

	const columns = ColumnsConfig({
		onView: handleView,
		onApprove: handleApprove
	});

	return (
		<PageWrapper title="Profile Management">
			<Space direction="vertical" size="large" style={{ width: "100%" }}>
				<div className={styles.tableContainer}>
					<Search
						placeholder="Search..."
						className="mb-4"
						allowClear
						size="large"
						style={{ maxWidth: 400 }}
						onSearch={handleSearch}
						onChange={(e) => handleSearch(e.target.value)}
					/>

					<Table
						className="clean-table"
						size="middle"
						loading={loading}
						columns={columns}
						rowKey="__rowId"
						scroll={{ x: 1200 }}
						bordered={false}
						dataSource={filteredData}
						pagination={{ pageSize: 10 }}
					/>
				</div>
			</Space>
			<StatusUpdateModal
				open={modalOpen}
				currentStatus="Ready"
				onCancel={() => setModalOpen(false)}
				onSave={(values) => {
					if (!selectedProfileId) return;
					handleApproveProfile(selectedProfileId, values.status, values.comment);
					setModalOpen(false);
					setSelectedProfileId(null);
				}}
			/>
			;
		</PageWrapper>
	);
};

export default InvoicePartnerList;
